import LightningIcon from '@src/components/icons/lightning'
import WalletIcon from '@src/components/icons/wallet'
import { useBounties } from '@src/context/BountiesContext'
import { t } from 'i18next'

const Icon = ({ isNotAnonymousUser, bountyProgress, isBountyActive }) => {
  if (!isNotAnonymousUser) {
    return <WalletIcon />
  }

  if (isBountyActive) {
    return <div className="font-bold">{bountyProgress}%</div>
  }

  if (bountyProgress === '0') {
    return <LightningIcon />
  }

  // Fallback for authenticated users without a specific icon condition
  return <LightningIcon />
}

export const MobileWallet = ({ mainButtonClickHandler, me }) => {
  const { bountyProgress, isBountyActive } = useBounties()
  const isNotAnonymousUser = null === me?.anonymousHash

  return (
    <button
      onClick={mainButtonClickHandler}
      className={'relative inline-flex flex-col items-center justify-center text-whiteSmoke'}
      style={{ zIndex: 60 }}
    >
      <div
        className={`absolute w-55 h-55 border-2 border-yellow rounded-full ${
          bountyProgress === '100' ? 'animate-pulse' : 'animate-none'
        }`}
        style={{ bottom: '87%', left: '50%', transform: 'translate(-50%, 50%)' }}
      ></div>
      <div
        className={`bg-gradient-to-r-custom w-50 h-50 rounded-full flex items-center justify-center shadow-top -mb-18`}
        style={{ transform: 'translateY(-47%)' }}
      >
        <Icon isNotAnonymousUser={isNotAnonymousUser} bountyProgress={bountyProgress} isBountyActive={isBountyActive} />
      </div>
      <span className="text-xs">
        {isNotAnonymousUser ? t('profile.dashboard.bonus', 'Bonus') : t('menu.wallet', 'Wallet')}
      </span>
    </button>
  )
}

export default MobileWallet
